<template>

  <v-card class="mb-3">
    <v-card-title>
      <span class="headline">Update Merchant Order Verification URL</span>
    </v-card-title>

    <m-pay-confirm-dialog
      :show="showConfirmationDialog"
      title="Are you sure you want to update Merchant Order Verification URL?"
      @yes="update"
      @cancel="showConfirmationDialog = false"
      maxWidth="700px"
    />

    <m-pay-generic-editor
      :bean="merchant"
      :beanProperties="editableMerchantProperties"
      :beanLabels="labels"
      :validationRules="validationRules"
      :loading="loading"
      submitButtonColor="red"
      @submit="confirmUpdate"
      @change="setCurrentCallback"
    >
      <template slot="submitButton">
        Update
        <v-icon right dark>edit</v-icon>
      </template>
      <template slot="description">
        <div class="mb-4 subheading">
          URL will be accessed from public IP:<br/>{{ publicIp }}
          <m-pay-copy-button :value="publicIp"></m-pay-copy-button>
        </div>
      </template>
    </m-pay-generic-editor>
  </v-card>

</template>

<script>
import MPayGenericEditor from '../MPayGenericEditor';
import MPayConfirmDialog from '../MPayConfirmDialog';
import MPayCopyButton from '../MPayCopyButton';

export default {
  name: 'MPayMerchantOrderVerificationUrlEditor',
  props: {
    merchant: { required: true },
    loading: { required: true },
    publicIp: { required: true },
  },
  components: { MPayGenericEditor, MPayConfirmDialog, MPayCopyButton },
  data: () => ({
    showConfirmationDialog: false,
    editableMerchantProperties: [
      'orderVerificationUrl',
    ],
    labels: [
      'Order Verification URL',
    ],
    validationRules: [

    ],
    confirmedMerchant: {},
    userInputCallbackUrl: '',
  }),
  methods: {
    confirmUpdate(merchant) {
      this.showConfirmationDialog = true;
      this.confirmedMerchant = merchant;
    },
    update() {
      this.showConfirmationDialog = false;
      this.$emit('submit', this.confirmedMerchant);
    },
    setCurrentCallback(model) {
      this.userInputCallbackUrl = model.orderVerificationUrl;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantOrderVerificationUrlEditor.vue